<template>
  <div id="stepTem" class="step_tem">
    <!-- 设备日志 -->
    <div class="title_box clearfix">
      <p class="title fl"> {{ $t('allDeviceDetail.DeviceLog') }} </p>
      <el-button v-if="!$store.state.userInfo.guestFlag&&$route.query.showAll != 1" class="deviceInfoDetailBtn fr" icon="el-icon-plus" type="primary" @click="addStep" />
    </div>
    <div class="baseContentWarp" style="padding-left: 10px;">
      <p v-if="stepList.length==0" style="text-align: center;">{{ $t('yhubReport.Nodata') }}</p>
      <el-steps direction="vertical" :active="stepList.length" :space="70" finish-status="process">
        <el-step v-for="(item,index) in stepList" :key="index" :title="item.title" :description="item.description" />
      </el-steps>
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="addStepPop" width="60%" class="addStepPop">
      <el-form ref="addStepPop" :model="addStepObj" :rules="rules" label-position="right" label-width="180px" :inline="true">
        <el-form-item :label="$t('allDeviceDetail.LogRemark')" prop="remark">
          <el-input v-model="addStepObj.remark" type="textarea" style="width: 100%" :autosize="{ minRows: 3, maxRows: 8}" :placeholder="$t('warningSet.Pleaseenter')" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addStepPop = false">{{ $t('button.Cancel') }}</el-button>
        <el-button class="filter-item" type="primary" @click="submit('addStepPop')">{{ $t('button.Submit') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { getDateAndHour } from '@/utils/updateTime.js'
import { listDeviceLog, addDeviceLog } from '@/api/allDevice'
import i18n from '@/i18n'

export default {
  components: {
  },
  props: {
    mcuId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      stepList: [],
      addStepObj: {
        remark: ''
      },
      addStepPop: false,
      rules: {
        remark: [{ required: true, message: i18n.t('lease.Cannotbeblanked2'), trigger: 'blur' }]
      }
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    language(newValue, oldValue) {
      this.queryList()
    }
  },
  mounted() {
    setTimeout(() => {
      this.queryList()
    }, 50)
    this.$nextTick(() => {
      // setTimeout(() => {
      //   [...document.querySelectorAll('.el-steps .el-step__icon div')].forEach((el, index, arr) => {
      //     el.innerHTML = arr.length - index
      //   })
      // }, 500)
      this.queryIcon()
    })
  },
  methods: {
    queryList() {
      if (this.mcuId) {
        // listDeviceLog({ mcuId: '05d9ff393430475043152836' }).then(res => {
        listDeviceLog({ mcuId: this.mcuId }).then(res => {
          console.log(res)
          if (res.resultCode != 1001 || !res.resultModel) return
          this.stepList = res.resultModel
          this.stepList.forEach(v => {
            v.title = getDateAndHour(v.createTime, 'noSecond')
            v.description = v.remark

            if (!v.remark) {
              let remark = this.$t('device_log.' + v.i18nKey)
              if (v.param) {
                const param = JSON.parse(v.param)
                for (const key in param) {
                  remark = remark.replace(key, param[key])
                }
              }
              v.description = remark
            }
          })
        })
      }
    },
    queryIcon() {
      setTimeout(() => {
        [...document.querySelectorAll('.el-steps .el-step__icon div')].forEach((el, index, arr) => {
          el.innerHTML = arr.length - index
        })
      }, 500)
    },
    addStep() {
      this.addStepPop = true
      this.addStepObj.remark = ''
    },
    submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var param = {
            'mcuId': this.mcuId,
            'remark': this.addStepObj.remark
          }
          this.$confirm(i18n.t('button.ConfirmSubmit'), '', {// '确定提交吗？'
            confirmButtonText: i18n.t('button.Confirm'), // '确定',
            cancelButtonText: i18n.t('button.Cancel'),
            type: 'warning'
          }).then(() => {
            addDeviceLog(param).then(res => {
              if (res.resultCode === 1001) {
                this.$message({
                  type: 'success',
                  message: 'Succeed!'
                })
                this.addStepPop = false
                this.queryList()
                this.queryIcon()
              }
            })
          }).catch(() => { })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.addStepPop .el-dialog {
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#stepTem .el-step__description {
  margin: 2px 0 10px;
}

.step_tem {
  background-color: #fff;
  padding: 10px;
  margin-bottom: 30px;
  height: 480px;
  overflow-y: scroll;
  margin-right: -16px;
}
</style>
